module.exports = __webpack_public_path__ + "img/slide8.bf2789e5.jpg";